"use client"

import type React from "react"
import { useState } from "react"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import TurnstileAssignmentList from "./TurnstileAssignmentList"
import TurnstileAssignmentModal from "./TurnstileAssignmentModal"
import type { TurnstileAssignment } from "../turnstile/types"

const TurnstileAssignmentContainer: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedAssignment, setSelectedAssignment] = useState<TurnstileAssignment | null>(null)
  const [refreshTrigger, setRefreshTrigger] = useState(false)

  const handleOpenAdd = () => {
    setSelectedAssignment(null)
    setModalOpen(true)
  }

  const handleOpenEdit = (assignment: TurnstileAssignment) => {
    setSelectedAssignment(assignment)
    setModalOpen(true)
  }

  const handleSuccess = () => {
    setModalOpen(false)
    setRefreshTrigger((prev) => !prev)
  }

  return (
    <>
      <Breadcrumbs mainTitle="Turnstile Assignments" parent="Access Control" />
      <Container fluid>
        <Row>
          <Col md="12">
            <TurnstileAssignmentList
              onAdd={handleOpenAdd}
              onEdit={handleOpenEdit}
              refreshTrigger={refreshTrigger}
              onRefresh={() => setRefreshTrigger((prev) => !prev)}
            />
          </Col>
        </Row>

        <TurnstileAssignmentModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          onSuccess={handleSuccess}
          initialData={selectedAssignment}
        />
      </Container>
    </>
  )
}

export default TurnstileAssignmentContainer
